/** Static prose, baked at build time like the rest of /docs. */
export const prerender = true;
